import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Typography,
    Divider,
    Box,
    styled,
    Stack,
    IconButton,
    Tooltip
} from "@mui/material";
import PaperDraggable from "../../../../../../../components/PaperDraggable";
import { IDataDetalharPedido } from "../../../../../../../types/api/comercial/detalhar-pedido";
import ChipWithTooltip from "../../../../../../../components/ChipWithTooltip";
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import useImprimirArquivo from "../../../../../../../lib/useImprimirArquivo";
import { useState } from "react";
import DialogVisualziarBulas from "./DialogExpedirItens/DialogVisualziarBulas";

export default function DialogVisualizarReceituario({
    open,
    data,
    handleClose,
}: DialogVisualizarReceituarioProps
) {

    const imprimirArquivo = useImprimirArquivo()

    //Transforma o array de itens em um objeto onde a chave é o id da receita
    const itemReceituario: TItemReceituario = data.itens
        .filter(item => item.emite_receita === "S" && item.receita_id !== null)
        .reduce<TItemReceituario>((acc, item) => {
            const key = String(item.receita_id);
            if (!acc[key]) {
                acc[key] = [];
            }
            acc[key].push(item);
            return acc;
        }, {} as TItemReceituario);

    const [openModalBula, setOpenModalBula] = useState<TProdutosArquivoBula | null>(null);
    const [arquivosBulas] = useState<TArquivosBulas[]>(
        Object.entries(itemReceituario).map(([receitaId, items]) => {
            const itemBula = items.map(item => (
                { arquivo_id: item.arquivo_bula_id || 0, produto_nome: item.nome }
            ))

            return { [receitaId]: itemBula };
        })
    );


    //Funções de controle
    const handleImprimir = (receitaId: string) => {
        imprimirArquivo("receituario-agronomico/imprimir-receita/" + receitaId + '?segunda_via=true')
    }

    const handleImprimirBula = (arquivo_bula_id: number) => {
        imprimirArquivo(`imprimir-arquivo/${arquivo_bula_id}`)
    }

    return (
        <>
            <Dialog
                open={open}
                onClose={handleClose}
                maxWidth="md"
                PaperComponent={PaperDraggable}
                aria-labelledby="draggable-dialog-title"
                fullWidth
            >
                <DialogTitle
                    style={{ cursor: 'move' }}
                    id="draggable-dialog-title"
                >
                    <Typography variant="h6" component="div">
                        Visualizar Receituários
                    </Typography>
                </DialogTitle>
                <Divider />
                <DialogContent>
                    {Object.keys(itemReceituario).length > 0 ? (
                        <TableContainer component={Paper} elevation={2}>
                            <Table size="medium">
                                <StyledTableHead>
                                    <TableRow>
                                        <HeaderTableCell>Código</HeaderTableCell>
                                        <HeaderTableCell>Produto</HeaderTableCell>
                                        <HeaderTableCell>Cultura</HeaderTableCell>
                                        <HeaderTableCell>Praga</HeaderTableCell>
                                        <HeaderTableCell align="center">Ações</HeaderTableCell>
                                    </TableRow>
                                </StyledTableHead>
                                <TableBody>
                                    {
                                        Object.entries(itemReceituario).map(([receitaId, items]) => {
                                            return (
                                                <StyledTableRow key={receitaId}>
                                                    <StyledTableCell>{receitaId}</StyledTableCell>
                                                    <StyledTableCell>
                                                        {items[0].nome}
                                                        {
                                                            items.length > 1 &&
                                                            <ChipWithTooltip
                                                                label={`+${items.slice(1).length}`}
                                                                extraLabels={items.slice(1).map((item) => item.nome)}
                                                            />
                                                        }
                                                    </StyledTableCell>
                                                    <StyledTableCell>{items[0].cultura?.nome || '-'}</StyledTableCell>
                                                    <StyledTableCell>{items[0].praga?.nome || '-'}</StyledTableCell>
                                                    <StyledTableCell align="center">
                                                        <Stack direction="row" spacing={1} justifyContent="center">
                                                            <Tooltip title="Ver receituário">
                                                                <IconButton
                                                                    size="small"
                                                                    onClick={() => { handleImprimir(receitaId) }}
                                                                    color="primary"
                                                                >
                                                                    <VisibilityOutlinedIcon />
                                                                </IconButton>
                                                            </Tooltip>
                                                            {
                                                                arquivosBulas && arquivosBulas.length > 0 && arquivosBulas.map((item) => {

                                                                    if (item[receitaId] && item[receitaId].length === 1) {
                                                                        return item[receitaId].map((bula, index) => (
                                                                            bula.arquivo_id && bula.arquivo_id !== 0 ? (
                                                                                <Tooltip key={index} title={`Consultar bula - ${bula.produto_nome}`}>
                                                                                    <IconButton
                                                                                        size="small"
                                                                                        onClick={() => handleImprimirBula(bula.arquivo_id)}
                                                                                        color="primary"
                                                                                    >
                                                                                        <DescriptionOutlinedIcon />
                                                                                    </IconButton>
                                                                                </Tooltip>
                                                                            ) : null
                                                                        ))
                                                                    }

                                                                    if (item[receitaId] && item[receitaId].length > 1)
                                                                        return (
                                                                            <Tooltip title={`Visualizar bulas`}>
                                                                                <IconButton
                                                                                    size="small"
                                                                                    onClick={() => setOpenModalBula(item[receitaId] || null)}
                                                                                    color="primary"
                                                                                >
                                                                                    <DescriptionOutlinedIcon />
                                                                                </IconButton>
                                                                            </Tooltip>
                                                                        )

                                                                    return (null)
                                                                })

                                                            }
                                                        </Stack>
                                                    </StyledTableCell>
                                                </StyledTableRow>
                                            )
                                        })
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    ) : (
                        <EmptyStateBox>
                            <Typography variant="body1" gutterBottom>
                                Nenhum receituário encontrado
                            </Typography>
                            <Typography variant="body2">
                                Não há receituários disponíveis para este pedido.
                            </Typography>
                        </EmptyStateBox>
                    )}
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Button
                        onClick={handleClose}
                        variant="text"
                        color="primary"
                    >
                        Fechar
                    </Button>
                </DialogActions>
            </Dialog>
            {
                openModalBula &&
                <DialogVisualziarBulas
                    open={Boolean(openModalBula)}
                    bulas={openModalBula}
                    handleClose={() => setOpenModalBula(null)}
                />
            }
        </>
    )
}

const StyledTableHead = styled(TableHead)(({ theme }) => ({
    backgroundColor: theme.palette.grey[100],
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:hover': {
        backgroundColor: theme.palette.action.hover,
    },
    transition: theme.transitions.create('background-color'),
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    padding: theme.spacing(2),
    border: 'none'
}));

const HeaderTableCell = styled(TableCell)(({ theme }) => ({
    padding: theme.spacing(2),
    fontWeight: 'bold',
    border: 'none'
}));

const EmptyStateBox = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(4),
    backgroundColor: theme.palette.grey[50],
    borderRadius: theme.shape.borderRadius,
    color: theme.palette.text.secondary,
    margin: theme.spacing(2, 0),
}));

interface DialogVisualizarReceituarioProps {
    open: boolean;
    handleClose: () => void;
    data: IDataDetalharPedido
}

type TItemReceituario = {
    [key: string]: IDataDetalharPedido["itens"]
}

export type TArquivosBulas = {
    [key: string]: TProdutosArquivoBula;
};

export type TProdutosArquivoBula = {
    arquivo_id: number;
    produto_nome: string;
}[];
